import {
  FirestoreDocCategory,
} from "breadcommon";
import { RyeModalContent } from "../rye/RyeModal";
import { firestoreDeleteCategoryByIdAndUpdateRelationships } from "../firebaseio/firestoreIo";
import { useState, useContext } from "react";
import { RyeDropDown } from "../rye/RyeDropDown";
import { buildClasses } from "../utils/buildClasses";
import { UserContext } from "../firebaseio/UserContext";
import { CategoryGroupsContext } from "../firebaseio/CategoryGroupsContext";
import { CategoriesContext } from "../firebaseio/CategoriesContext";
import { TransactionsContext } from "../firebaseio/TransactionsContext";

export function DeleteCategoryModal({
  category,
}: {
  category: FirestoreDocCategory | null;
}): JSX.Element {
  const user = useContext(UserContext);
  const categories = useContext(CategoriesContext);
  const categoryGroups = useContext(CategoryGroupsContext);
  const transactions = useContext(TransactionsContext);
  const [replacementCategoryId, setReplacementCategoryId] = useState<
    string | null
  >(null);

  const numMatchingTransactions = Array.from(transactions.values()).filter(
    (transaction) => transaction.categoryId === category?.id,
  ).length;

  let content = (
    <div>This category is not currently assigned to any transactions.</div>
  );
  if (numMatchingTransactions !== 0) {
    content = (
      <div className={buildClasses("w-full")}>
        <div
          className={buildClasses("whitespace-pre")}
        >{`This category is currently assigned to ${numMatchingTransactions} transaction${
          numMatchingTransactions === 1 ? "" : "s"
        }.\nPlease choose which category to assign instead.`}</div>
        <div className="h-5" />
        <RyeDropDown<string>
          initEntryId={replacementCategoryId}
          entries={Array.from(categories)
            .filter(([id, _]) => id !== category?.id)
            .map(([id, category]) => {
              return {
                id: id,
                text: category.name,
                icon: category.emoji,
                groupId: category.category_group_id,
              };
            })}
          groups={Array.from(categoryGroups.values())
            .sort((a, b) => a.order_position - b.order_position)
            .map((group) => ({
              id: group.id,
              label: group.name,
            }))}
          onSelectEntry={(entry) => setReplacementCategoryId(entry.id)}
          searchable
          width="full"
        />
      </div>
    );
  }

  return (
    <RyeModalContent
      actionButtons={[
        {
          text: "Cancel",
          vibe: "subdued",
          variant: "outlined",
          action: () => {},
        },
        {
          text: "Delete category",
          vibe: "danger",
          variant: "filled",
          disabled:
            numMatchingTransactions > 0 && replacementCategoryId === null,
          action: () => {
            if (category !== null) {
              firestoreDeleteCategoryByIdAndUpdateRelationships(
                user.uid,
                category,
                replacementCategoryId,
                Array.from(categories.values()),
              );
            }
          },
        },
      ]}
      title={`Delete "${category?.emoji}  ${category?.name}" category?`}
      content={content}
    ></RyeModalContent>
  );
}
